

export default function AdminDashboard() {
   

    return <div>Admin</div>
}